module.exports = "/_next/static/images/BBFC-2dcd7e93eb6627a2be7f649f7af2b3ab.png";